/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkloadQueryWorkloadId extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("WorkloadQueryWorkloadId");
    }

    getFixupPrototypeFunction() { return WorkloadQueryWorkloadId.fixupPrototype; }

    static newInstance(model: Partial<WorkloadQueryWorkloadId>): WorkloadQueryWorkloadId {
        let obj = Object.assign(new WorkloadQueryWorkloadId(), model);
        WorkloadQueryWorkloadId.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkloadQueryWorkloadId>): WorkloadQueryWorkloadId {
        if (!model) return null;
        return WorkloadQueryWorkloadId.newInstance(<WorkloadQueryWorkloadId> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkloadQueryWorkloadId) {
        if (!obj) return;

        models.WorkloadQueryWorkloadId.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkloadQueryWorkloadId): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, WorkloadQueryWorkloadId.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * ID of the Workload
     */
    workload_ids: Array<string>;

}
